<div *ngIf="showBanner && !isWhiteLabel" class="banner show">
    <i class="material-icons" (click)="closeBanner()">close</i>
    <p>Baixe o app <strong>Auto Arremate | Exchange</strong> e receba notificações da sua negociação em tempo real.</p>
    <button (click)="redirectToAppStore()" class="btn btn-primary btn-rounded text-white download-app">
        baixar o aplicativo
    </button>
</div>
  